import {useContext} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {ICONS} from 'patient-ping-remedy/packages/icon';
import IconButton from 'patient-ping-remedy/packages/icon-button';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {useAuthStore} from '@/store/auth_store';
import {useRosterStore} from '@/store/roster_store';
import {useWebSocketSubscription} from '@/hooks/useWebSocketSubscription';
import {useMessageThreadInbox} from '@/hooks/useMessageThreadInbox';

export default function MessagesWidgetIcon() {
  const { webSocketApi } = useContext(CarecoApiContext);
  const currentUser = useAuthStore((state) => state.currentUser);
  const currentRoster = useRosterStore((state) => state.currentRoster);
  const queryClient = useQueryClient();

  const handleNewMessage = () => {
    void queryClient.invalidateQueries({ queryKey: ['messageThreadInbox', true] });
    void queryClient.invalidateQueries({ queryKey: ['messageThreadInbox', false] });
  };

  useWebSocketSubscription(
    () => {
      if (currentUser && currentRoster) {
        return webSocketApi?.subscribeToMessages(currentUser.id, currentRoster.id, handleNewMessage);
      }
    },
    [currentUser, currentRoster],
    [currentRoster],
  );

  const { totalUnreadMessages } = useMessageThreadInbox({
    onlyShowUnreadMessages: true,
    onlyUpdateCount: true,
  });

  const badge = totalUnreadMessages === 0
    ? ''
    : totalUnreadMessages > 99
      ? '99+'
      : totalUnreadMessages;

  return (
    <IconButton
      iconClass={ICONS['comment-alt-dots']}
      badge={badge}
      overflowBackground
    />
  );
}
